import { Link } from "react-router-dom";
import styled from "styled-components";

const Bar = styled.header`
  position: fixed; inset: 0 0 auto; z-index: 1000; height: 80px;
  background: #071c2df5; border-bottom: 1px solid #24495a;
  color: #fff; backdrop-filter: blur(12px);
  > div { max-width: 1200px; height: 100%; margin: auto; padding: 0 28px; display: flex; justify-content: space-between; align-items: center; gap: 18px; }
  a { color: #e4edf1; font-size: .8rem; }
  a:hover { color: #7fcdcd; }
  a:focus-visible, summary:focus-visible { outline: 2px solid #7fcdcd; outline-offset: 6px; }
  .identity { color: #e4c28c; font-family: "DIN Condensed", "Arial Narrow", sans-serif; font-weight: 700; line-height: 1.1; letter-spacing: .04em; font-size: 1.65rem; }
  nav { display: flex; gap: 26px; }
  details { display: none; }
  @media (max-width: 768px) {
    height: 70px;
    > div { padding: 0 20px; }
    .identity { font-size: clamp(1.2rem, 5vw, 1.45rem); }
    nav { display: none; }
    details { display: block; }
    summary { cursor: pointer; color: #7fcdcd; font-size: .85rem; padding: 12px 0 12px 12px; }
    details > div { position: absolute; top: 69px; right: 0; left: 0; padding: 20px; background: #0d293b; border-bottom: 1px solid #7fcdcd; display: grid; gap: 4px; }
    details a { display: block; padding: 12px; }
  }
`;
const links = [["Home", "/"], ["About", "/about"], ["Ministries", "/ministries"], ["Events", "/events"], ["Books", "/books"], ["Contact", "/contact"]];
export default function HomeNavigation({ activePath = "/" }) {
  return <Bar><div><Link className="identity" to="/">THE MUSIC CHURCH</Link>
    <nav aria-label="Main navigation">{links.map(([label, path]) => <Link key={path} to={path} aria-current={path === activePath ? "page" : undefined}>{label}</Link>)}</nav>
    <details><summary>Menu</summary><div>{links.map(([label, path]) => <Link key={path} to={path} onClick={e => e.currentTarget.closest("details").removeAttribute("open")}>{label}</Link>)}</div></details>
  </div></Bar>;
}
